import * as React from "react";
import { Link } from "gatsby";

const Header = () => {
  return (
    <nav>
      <Link to="/">
        <h4 className="projects">projects</h4>
      </Link>
      <Link to="/" className="logo">
        <h1>Marysia Popławska</h1>
        <h4>Costume Designer</h4>
      </Link>
      <Link to="/" className="logo-mobile">
        <h1>M Popławska</h1>
      </Link>
      <Link to="/contact">
        <h4 className="contact">contact</h4>
      </Link>
    </nav>
  );
};

export default Header;
